import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '@/components/PageHero';
import FadeInUp from '@/components/FadeInUp';
import { CheckIcon, ArrowRight, LicenseIcon, CertificateIcon } from '@/components/icons';

export default function FEndorsement() {
  return (
    <>
      <PageHero
        eyebrow="“F” Endorsement Driver's Licence"
        title="Drive a registered forklift on public roads."
        subtitle="Required for any operator who needs to drive a registered forklift on a public roadway. Add to any standard course at time of booking."
        image="/generated/course-reach-truck.png"
        breadcrumbs={[{label:'Home', to:'/'}, {label:'Courses', to:'/courses'}, {label:'F Endorsement'}]}
        badge="Optional Extra — Advise at Booking"
      />

      <section className="nft-container py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-8">
            <FadeInUp>
              <div>
                <div className="label-eyebrow text-[#FC4E2C] mb-2">What is it?</div>
                <h2 className="font-display font-extrabold uppercase text-3xl lg:text-4xl text-[#060D9C] leading-tight">
                  An endorsement on your driver's licence.
                </h2>
                <p className="mt-4 text-[#060D9C]/80 leading-relaxed">
                  This endorsement is required for any operator who needs to drive a registered forklift on a public roadway. NFT runs the assessment as an add-on to your Standard or Beginner course, or can be completed at any time within the 3 years on your current NFT certificate.
                </p>
              </div>
            </FadeInUp>

            <FadeInUp>
              <div data-testid="f-endorsement-requirements">
                <div className="label-eyebrow text-[#FC4E2C] mb-2">Requirements</div>
                <h3 className="font-display font-extrabold uppercase text-2xl lg:text-3xl text-[#060D9C] leading-tight">
                  What you need to bring.
                </h3>
                <ul className="mt-5 space-y-3">
                  {[
                    'Additional 1-hour training session (added to your day)',
                    'Questions and a practical assessment based on the road code',
                    'Minimum full Class 1 driver’s licence — must be presented on the day',
                  ].map((r) => (
                    <li key={r} className="flex items-start gap-3 surface-card p-4">
                      <span className="shrink-0 w-9 h-9 rounded-lg bg-[#FC4E2C]/15 text-[#FC4E2C] flex items-center justify-center">
                        <CheckIcon width={18} height={18} />
                      </span>
                      <span className="text-[#060D9C]/85 text-sm leading-relaxed pt-1">{r}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </FadeInUp>

            <FadeInUp>
              <div className="callout-warning">
                <div className="label-eyebrow text-[#060D9C] mb-1">NZQA Note</div>
                <p className="text-sm text-[#060D9C]/85">
                  If you require <strong>Unit Standard 18496</strong> on your record of learning, you <strong>MUST</strong> bring your NZQA (NSN) number with you on the day of training.
                </p>
              </div>
            </FadeInUp>
          </div>

          <aside className="lg:col-span-5">
            <div className="lg:sticky lg:top-32 surface-card p-6">
              <div className="w-12 h-12 rounded-xl bg-[#FC4E2C]/15 text-[#FC4E2C] flex items-center justify-center mb-4">
                <LicenseIcon width={26} height={26} />
              </div>
              <div className="label-eyebrow text-[#FC4E2C] mb-2">At a Glance</div>
              <h3 className="font-display font-extrabold uppercase text-2xl text-[#060D9C] leading-tight">“F” Endorsement add-on</h3>
              <ul className="mt-4 space-y-2 text-sm text-[#060D9C]/85">
                <li><strong>Duration:</strong> +1 hour</li>
                <li><strong>Format:</strong> Theory questions + practical assessment</li>
                <li><strong>Prereq:</strong> Full Class 1 NZ driver’s licence</li>
                <li><strong>Cost:</strong> Extra fee per trainee in addition to Standard Course charges</li>
              </ul>
              <div className="mt-6 pt-6 border-t border-[#060D9C]/10">
                <Link to="/booking" className="btn-primary-orange w-full justify-center" data-testid="f-endorsement-book-cta">
                  Add to my booking <ArrowRight width={16} height={16} />
                </Link>
              </div>
              <p className="mt-3 text-xs text-[#060D9C]/60 text-center">
                Mention “F Endorsement” in your enquiry message.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
